import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  StyledFlex,
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
  StyledSubTableContainer,
} from "@/common/styles";
import {
  getOptionsFromRefList,
  hasCheckSecurity,
} from "@/util/common_function";
import Modal from "@/common/elements/Modal";
import Button from "@/common/elements/Button";
import JailIncidentsInvolvedDetail from "./JailIncidentsInvolvedDetail";
import DataTable from "@/common/elements/DataTable";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import { MODULES_LIST_WITH_ID } from "@/util/common_variable";

const JailIncidentsDetails = () => {
  const bookings = useSelector((state) => state.bookings?.bookings);
  const jailIncidentsInvolvedInmate =
    bookings?.jailIncidentsInvolvedInmate || [];

  const [selectedIncident, setSelectedIncident] = useState(null);
  const [showInvolvedInmate, setShowInvolvedInmate] = useState(false);

  const [tableData, setTableData] = useState({
    headers: [
      { key: "incidentNumber", text: "#" },
      { key: "date", text: "Date" },
      { key: "name", text: "Name" },
      { key: "involvement", text: "Involvement" },
      { key: "disciplinary", text: "Disciplinary" },
      { key: "synopsis", text: "Synopsis" },
    ],
    rows: [],
  });

  useEffect(() => {
    if (jailIncidentsInvolvedInmate?.length>0) {
      const rows = jailIncidentsInvolvedInmate?.map((incident) => ({
        ...incident,
        id: incident.jailIncidents[0]?.jailIncidentID || "-",
        incidentNumber: incident.jailIncidents[0]?.incidentNumber || "-",
        date: incident.jailIncidents[0]?.reportDate || "-",
        name:
          bookings?.bio?.[0]?.lName +
          ", " +
          bookings?.bio?.[0]?.fName +
          " " +
          bookings?.bio?.[0]?.mName,
        involvement: incident?.jailIncidentsInvolvementType || "-",
        disciplinary: incident?.disciplineRequired || "-",
        synopsis: incident.jailIncidents[0]?.synopsis || "-",
        onClick: () => setSelectedIncident(incident),
      }));
      setTableData((prev) => ({ ...prev, rows }));
    } else {
      setTableData((prev) => ({ ...prev, rows: [] }));
      setSelectedIncident(null);
    }
  }, [jailIncidentsInvolvedInmate]);

  const onHandleIncidentView = () => {
    if (selectedIncident) {
      setShowInvolvedInmate(true);
    }
  };

  return (
    <>
      {/* <StyledGridRow>
           <StyledGridCol span={24}>
              <IncidentsList
              switchToBookingIncident = {onHandleIncidentView} 
              isBookingIncident={true}/>
           </StyledGridCol>
        </StyledGridRow> */}

      <StyledSectionHeading marginTop="0px">
        <span>Jail Incidents</span>
      </StyledSectionHeading>

      <StyledSubTableContainer>
        <StyledFlex align="center" justify="space-between">
          <h2>Jail Incidents Involved Inmate</h2>

          <StyledFlex marginBottom="5px">
            <Button
              onClick={onHandleIncidentView}
              // disabled={
              //   !selectedIncident ||
              //   !hasCheckSecurity(
              //     Security_Types.functionality,
              //     Entity_types.module,
              //     LABELS_CAPITAL.ADD,
              //     MODULES_LIST_WITH_ID.MODULE_BOOKINGS
              //   )
              // }
            >
              Details
            </Button>
          </StyledFlex>
        </StyledFlex>

        <DataTable
          headers={tableData.headers}
          data={tableData.rows}
          onRowClick={(row) => setSelectedIncident(row)}
        />
      </StyledSubTableContainer>

      {showInvolvedInmate && (
        <Modal
          designPattern="ant"
          header="Jail Incidents Involved Inmate Details"
          show={showInvolvedInmate}
          onHide={() => setShowInvolvedInmate(false)}
          handleCancel={() => setShowInvolvedInmate(false)}
          size="xl"
          width="75%"
          footerActions={[
            <Button
              type="secondary"
              color="secondary"
              onClick={() => setShowInvolvedInmate(false)}
              key="close"
            >
              Close
            </Button>,
          ]}
        >
          {/* <AddJailIncident /> */}

          {/* Involved Detail */}
          <JailIncidentsInvolvedDetail
            data={selectedIncident}
            bookings={bookings}
          />
        </Modal>
      )}
    </>
  );
};

export default JailIncidentsDetails;
